<template>
<v-autocomplete
    :label="label"
    autocomplete="off"
    :items="items"
    data-lpignore="true"
    :value="value"
    v-on:input="$emit('input',$event)"
    :clearable="clearable"
>
</v-autocomplete>
</template>

<script>
const _ = require('lodash');

export default {
    props: {
        value: {
            type: String,
            default: function() { return null; },
        },

        label: {
            type: String,
            default: function() { return 'Pick one'; }
        },

        type: {
            type: String,
            default: function() { return 'organization'; }
        },

        path: {
            type: String,
            default: function() { return null; },
        },

        params: {
            type: Object,
            default: function() { return {}; }
        },

        clearable: {
            type: Boolean,
            default: function() { return true; }
        },

        endpoint: {
            type: String,
            default: function() { return null; }
        },
    },

    data() {
        return {
            items: [
            ],
        }
    },

    mounted () {
        this.updateItems();
    },

    methods: {
        updateItems() {
            let endpoint = this.endpoint;
            let params = _.cloneDeep(this.params);

            if ( endpoint == null )
            {
                if ( this.type == 'organization' )
                {
                    endpoint = 'LIST: /api/v1/autocomplete/organizations';
                    params.is_archived = false;
                }

                if ( this.type == 'organization-all' )
                {
                    endpoint = 'LIST: /api/v1/autocomplete/organizations';
                    params.is_archived = null;
                }

                if ( this.type == 'system-admins' )
                {
                    endpoint = 'LIST: /api/v1/autocomplete/employees';
                    params.is_system_admin = true;
                }

                if ( this.type == 'employees' )
                {
                    endpoint = 'LIST: /api/v1/autocomplete/employees';
                    params.is_archived = false;
                }

                if ( this.type == 'bulk_message' )
                {
                    endpoint = 'LIST: /api/v1/autocomplete/bulk_message';
                    params.is_archived = null;

                    if ( this.$route.params.bulk_message_id != null )
                    {
                        params.bulk_message_id = { type: 'not-equals', value: this.$route.params.bulk_message_id};
                    }
                }

                if ( this.type == 'bulk_message_group' )
                {
                    endpoint = 'LIST: /api/v1/autocomplete/bulk_message_group';
                }

                if ( this.type == 'lists' )
                {
                    endpoint = 'LIST: /api/v1/autocomplete/lists';
                }

                if ( endpoint == null )
                {
                    this.items = [];
                    return;
                }
            }

            this.$rc.rest({
                'spinner': false,
                'endpoint': endpoint,
            
                'params' : params,
            
                'on_success': (data) => {
                        this.items = data.results;
                    },
            
                'on_error': () => {
                    this.items = [];
                },
            });
        }
    },

    watch: {
        type(newValue, oldValue) {
           this.updateItems(); 
        },

        endpoint(newValue, oldValue) {
           this.updateItems(); 
        },
    },
}
</script>

<style lang="scss" scoped>

</style>